import React from 'react';
const isValidDotListDataItem = ({ content }) => {
    if (content === undefined || content === null) {
        return false;
    }
    return true;
};
const resolveContent = ({ children, data }) => {
    if (children) {
        return children;
    }
    return data?.filter(isValidDotListDataItem).map(({ content, key }) => <li key={key}>{content}</li>);
};
export const useDotList = (props) => ({
    content: resolveContent(props),
});
